import axios from 'axios';
import { toast } from "react-toastify";

const PROXY = process.env.REACT_APP_URL + "api/";

export const contactUs = (data) => async (dispatch) => {

    try {
        const res = await axios.post(`${PROXY}contact/add`, data);
        // toast.success(res?.data?.message);
        return res;
    } catch (err) {
        toast.error(err?.response?.data?.message)
    }
}
